import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container:{
        width: '90%',
        marginLeft: '5%',
        marginRight: '5%',
        minHeight: '20px',
        color: '#666666',
        padding: '15px',
        fontSize: '1.2em',
        textAlign: 'center'
    },
    textDanger:{
        color: '#D63C43'
    },
    body:{
        paddingTop: '15px'   
    },
    note:{
        color: '#D63C43',
        fontWeight: 700
    },
    icon:{
        color: '#f3cb19',
        fontSize: '3em'
    }
}));

export default useStyles;
